import Button, { ButtonProps } from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";

type ExtendedButtonProps = ButtonProps & {
  testId?: string;
  startAddIcon?: boolean;
  endAddIcon?: boolean;
};

const CustomizedButton = ({
  sx,
  variant,
  title,
  onClick,
  startIcon,
  type,
  fullWidth,
  color,
  size,
  disabled,
  id,
  testId,
  endIcon,
  startAddIcon,
  endAddIcon,
}: ExtendedButtonProps) => {
  return (
    <Button
      id={id}
      data-test-id={testId}
      sx={{ p: variant === "text" ? 1 : undefined, ...sx }}
      type={type || "button"}
      size={size || "medium"}
      variant={variant}
      onClick={onClick}
      startIcon={startAddIcon ? <AddIcon /> : startIcon}
      endIcon={endAddIcon ? <AddIcon /> : endIcon}
      fullWidth={fullWidth}
      style={{ lineHeight: "normal", minWidth: 100 }}
      color={color}
      disabled={disabled}
      formNoValidate
    >
      {title}
    </Button>
  );
};

export default CustomizedButton;
